import * as React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry.js';
import { Sentry } from './sentry.js';
import './index.css';
import { App } from './App.js';
import { usePlayerStore } from './store/player.js';

// Expose React globally so user-created board.tsx bundles can use it
// without bundling their own copy (they reference globalThis.__PLAYGROUND_REACT__)
(globalThis as Record<string, unknown>)['__PLAYGROUND_REACT__'] = React;

// Hoist identity from URL into the player store BEFORE React renders.
// Prevents the zustand auto-generated uuid from leaking into first-render
// effects (e.g. App's /api/credits/<id> fetch).
{
  const params = new URLSearchParams(window.location.search);
  const urlUserId = params.get('userId');
  const urlDisplayName = params.get('displayName');
  if (urlUserId) usePlayerStore.getState().setPlayerId(urlUserId);
  if (urlDisplayName) usePlayerStore.getState().setDisplayName(urlDisplayName);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in the document.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Something broke. Reload to retry.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
